// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.RentalManagerUserPropertyEditWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertyEditWebApiHandler_isConnectedExperience,
  RentalManagerUserPropertyEditWebApiHandler_isConnectedExperience_Path,
  RentalManagerUserPropertyEditWebApiHandler_isListingEditable,
  RentalManagerUserPropertyEditWebApiHandler_isListingEditable_Path,
  RentalManagerUserPropertyEditWebApiHandler_pets,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  ListingAlias,
  UserPropertyEditPetsWebApiRequestDto,
  UserPropertyIsConnectedExperienceResponseWebDto,
} from '@zg-rentals/ts-rental-manager-api-client';

interface IsConnectedExperienceParams {
  listingAlias: ListingAlias;
}
interface IsListingEditableParams {
  listingAlias: ListingAlias;
  multiplexBuildingSessionId?: string;
}

export type RentalManagerUserPropertyEditWebApiHandler_isConnectedExperience_Options = UseQueryOptions<
  UserPropertyIsConnectedExperienceResponseWebDto,
  unknown,
  UserPropertyIsConnectedExperienceResponseWebDto,
  readonly [string, IsConnectedExperienceParams]
>;

const RentalManagerUserPropertyEditWebApiHandler_isConnectedExperience_GetKey = (
  getParams: IsConnectedExperienceParams,
) => [RentalManagerUserPropertyEditWebApiHandler_isConnectedExperience_Path, getParams] as const;

export const RentalManagerUserPropertyEditWebApiHandler_isConnectedExperience_queryOptions = (
  getParams: IsConnectedExperienceParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertyEditWebApiHandler_isConnectedExperience_GetKey(getParams),
    queryFn: () => RentalManagerUserPropertyEditWebApiHandler_isConnectedExperience(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get isConnectedExperience for a listing
 */
export const useRentalManagerUserPropertyEditWebApiHandler_isConnectedExperience = (
  getParams: IsConnectedExperienceParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserPropertyEditWebApiHandler_isConnectedExperience_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertyEditWebApiHandler_isConnectedExperience_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserPropertyEditWebApiHandler_isConnectedExperience.getKey =
  RentalManagerUserPropertyEditWebApiHandler_isConnectedExperience_GetKey;

export type RentalManagerUserPropertyEditWebApiHandler_isListingEditable_Options = UseQueryOptions<
  boolean,
  unknown,
  boolean,
  readonly [string, IsListingEditableParams]
>;

const RentalManagerUserPropertyEditWebApiHandler_isListingEditable_GetKey = (getParams: IsListingEditableParams) =>
  [RentalManagerUserPropertyEditWebApiHandler_isListingEditable_Path, getParams] as const;

export const RentalManagerUserPropertyEditWebApiHandler_isListingEditable_queryOptions = (
  getParams: IsListingEditableParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPropertyEditWebApiHandler_isListingEditable_GetKey(getParams),
    queryFn: () => RentalManagerUserPropertyEditWebApiHandler_isListingEditable(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Check whether the listing (or multiplex building units) can be edited; no side effects
 */
export const useRentalManagerUserPropertyEditWebApiHandler_isListingEditable = (
  getParams: IsListingEditableParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserPropertyEditWebApiHandler_isListingEditable_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserPropertyEditWebApiHandler_isListingEditable_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserPropertyEditWebApiHandler_isListingEditable.getKey =
  RentalManagerUserPropertyEditWebApiHandler_isListingEditable_GetKey;

export interface RentalManagerUserPropertyEditWebApiHandler_pets_Args {
  postData: UserPropertyEditPetsWebApiRequestDto;
}

export type RentalManagerUserPropertyEditWebApiHandler_pets_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyEditWebApiHandler_pets_Args
>;

/**
 * Update pet policy of a property
 */
export const useRentalManagerUserPropertyEditWebApiHandler_pets = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyEditWebApiHandler_pets_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyEditWebApiHandler_pets_Args) =>
      RentalManagerUserPropertyEditWebApiHandler_pets(args.postData, httpClient),
  });
};
